var map = {
	"./display_off.png": "c7Mt",
	"./display_on.png": "B5So"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xzR1";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head ^\.\/display_.*\.png$
// module id = xzR1
// module chunks = 3